module.exports = __webpack_public_path__ + "e473f640a3492697032cc51c5f44267f.png";